import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/lib/utils';

/**
 * Small status tag: 6 px radius, mono caption. The label is passed as
 * children and translated by the caller — never an enum value.
 */
const statusPillVariants = cva(
  'inline-flex h-6 items-center gap-1.5 whitespace-nowrap rounded-chip px-2 font-mono text-[11px] font-medium uppercase tracking-[0.08em]',
  {
    variants: {
      variant: {
        draft: 'bg-paper-3 text-ink-2',
        published: 'bg-success text-white',
        archived: 'bg-transparent text-mute ring-1 ring-inset ring-line',
        warning: 'bg-warning text-ink',
        danger: 'bg-danger text-white',
        neutral: 'bg-paper-3 text-ink',
      },
    },
    defaultVariants: {
      variant: 'neutral',
    },
  }
);

export interface StatusPillProps
  extends
    React.HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof statusPillVariants> {}

const StatusPill = React.forwardRef<HTMLSpanElement, StatusPillProps>(
  ({ className, variant, ...props }, ref) => (
    <span
      ref={ref}
      className={cn(statusPillVariants({ variant }), className)}
      {...props}
    />
  )
);
StatusPill.displayName = 'StatusPill';

export { StatusPill, statusPillVariants };
